export default __webpack_public_path__ + "static/media/directmartIcon.42bda094.jpg";